export const config = {
  title: 'Add Sticky Notes',
  okText: 'Save',
  width: 480,
  fields: [
    {
      name: 'heading',
      label: 'Heading',
      type: 'input',
      required: true,
      placeholder: 'Enter heading',
    },
    {
      name: 'targetDate',
      label: 'Target Date',
      type: 'date-picker',
      required: false,
    },
    {
      name: 'comments',
      label: 'Comments',
      type: 'mention-textarea',
      required: true,
      rows: 5,
      placeholder: "Enter your note here... Use '@' to mention someone.",
      mentionFetchKey: 'mentionUsers',
    },
  ],
};
